import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "grid md:grid-cols-2 gap-4" }
const _hoisted_4 = { class: "flex justify-end mt-7" }
const _hoisted_5 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_6 = { class: "grid gap-4" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex justify-end mt-7" }
const _hoisted_9 = { class: "flex justify-end items-center md:flex-grow" }
const _hoisted_10 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 177px)"}
}
const _hoisted_11 = { class: "custom-title flex flex-col" }
const _hoisted_12 = { class: "ml-auto" }
const _hoisted_13 = { class: "flex items-center space-x-1" }
const _hoisted_14 = { class: "text-white" }
const _hoisted_15 = { style: {"height":"calc(100vh - 227px)","overflow-y":"auto"} }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "hidden md:block w-full" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex w-full justify-end mt-4" }
const _hoisted_20 = { class: "hidden md:block mr-3" }
const _hoisted_21 = { class: "md:hidden" }
const _hoisted_22 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          style: {"height":"auto"},
          class: "bg-gray-200 p-3 md:p-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto",
                  "label-position": "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "組織名"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.searchForm.organization_name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.organization_name) = $event)),
                            placeholder: "組織名を入力"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_button, {
                          class: "hidden md:block w-24",
                          type: "info",
                          onClick: _ctx.handleSearchButton
                        }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode("検索")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _createVNode(_component_el_drawer, {
                class: "md:hidden bg-gray-200",
                modelValue: _ctx.drawer,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.drawer) = $event)),
                title: "検索",
                direction: "ttb",
                "with-header": false,
                size: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_form, {
                      model: _ctx.searchForm,
                      "label-width": "auto",
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_form_item, {
                              class: "no-margin flex-grow",
                              label: "組織名"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.searchForm.organization_name,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.organization_name) = $event)),
                                  placeholder: "組織名を入力"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_el_button, {
                                class: "md:hidden ml-3",
                                type: "info",
                                onClick: _ctx.handleSearchButton,
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn md:hidden",
                  type: "info",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drawer = true)),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn md:hidden",
                  type: "info",
                  onClick: _ctx.handleAddButton,
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " add ", -1)
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "hidden md:block w-24",
                  type: "info",
                  onClick: _ctx.handleAddButton
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode("新規登録")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                  ? (_openBlock(), _createBlock(_component_el_upload, {
                      key: 0,
                      class: "",
                      ref: "upload",
                      "on-change": _ctx.handleImportButton,
                      "auto-upload": false,
                      "show-file-list": false,
                      accept: ".csv"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          content: "CSVインポート",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              class: "custom-icon-btn mx-3",
                              type: "info",
                              circle: ""
                            }, {
                              default: _withCtx(() => _cache[23] || (_cache[23] = [
                                _createElementVNode("span", { class: "material-symbols-outlined" }, " upload_2 ", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["on-change"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn",
                  type: "info",
                  onClick: _ctx.handleExportButton,
                  circle: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      content: "CSVエクスポート",
                      placement: "top"
                    }, {
                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, " download_2 ", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[27] || (_cache[27] = _createElementVNode("span", null, "組織マスタ（組織名　払い出し操作者必須）", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-white" }, "ソート:", -1)),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSort('name'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'name' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createTextVNode(" 組織名 ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createElementVNode("span", _hoisted_14, "アイテム数: " + _toDisplayString(_ctx.mTotalRecords), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                  return (_openBlock(), _createBlock(_component_el_card, {
                    style: {"border":"1px solid #d1d5db","border-radius":"0px"},
                    key: item.organization_id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { align: "middle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 2 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "w-8 h-16",
                                type: "info",
                                style: {"background-color":"#b7b7b7"},
                                text: "",
                                bg: "",
                                onClick: ($event: any) => (_ctx.handleEditButton(item))
                              }, {
                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                  _createElementVNode("span", null, [
                                    _createTextVNode("詳"),
                                    _createElementVNode("br"),
                                    _createTextVNode("細")
                                  ], -1)
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 18,
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(item.name), 1),
                              _createVNode(_component_el_switch, {
                                modelValue: item.is_pay_must,
                                "onUpdate:modelValue": ($event: any) => ((item.is_pay_must) = $event),
                                "active-value": "1",
                                "inactive-value": "0",
                                onChange: ($event: any) => (_ctx.handlePayMustChange(item))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-xs text-gray-500 mt-1" }, "下位部署ユーザーの払い出し許可", -1)),
                              _createVNode(_component_el_switch, {
                                modelValue: item.is_sub_pay_to_head_enabled,
                                "onUpdate:modelValue": ($event: any) => ((item.is_sub_pay_to_head_enabled) = $event),
                                "active-value": "1",
                                "inactive-value": "0",
                                onChange: ($event: any) => (_ctx.handlePayMustChange(item))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 2,
                            class: "ml-2",
                            align: "right"
                          }, {
                            default: _withCtx(() => [
                              (item.organization_id !== _ctx.SYSTEM_ORGANIZATION)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "material-symbols-outlined cursor-pointer",
                                    onClick: ($event: any) => (_ctx.handleDeleteButton(item))
                                  }, " delete ", 8, _hoisted_16))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: _ctx.mTableData,
                height: "calc(100vh - 260px)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "組織マスタ",
                    width: "100",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        class: "w-12",
                        type: "info",
                        style: {"background-color":"#b7b7b7"},
                        text: "",
                        bg: "",
                        onClick: ($event: any) => (_ctx.handleEditButton(scope.row))
                      }, {
                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                          _createElementVNode("span", null, "詳細", -1)
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "organization_id",
                    label: "コード"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSort('organization_id')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('organization_id')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'organization_id' }])
                            }, _toDisplayString(_ctx.getSortIcon('organization_id')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "組織名"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSort('name')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('name')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'name' }])
                            }, _toDisplayString(_ctx.getSortIcon('name')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "is_pay_must",
                    label: "払い出し操作者必須",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_switch, {
                        modelValue: scope.row.is_pay_must,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.is_pay_must) = $event),
                        "active-value": "1",
                        "inactive-value": "0",
                        onChange: ($event: any) => (_ctx.handlePayMustChange(scope.row))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "is_sub_pay_to_head_enabled",
                    label: "下位部署ユーザーの払い出し許可",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_switch, {
                        modelValue: scope.row.is_sub_pay_to_head_enabled,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.is_sub_pay_to_head_enabled) = $event),
                        "active-value": "1",
                        "inactive-value": "0",
                        onChange: ($event: any) => (_ctx.handlePayMustChange(scope.row))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "updated_date",
                    label: "更新日"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleSort('updated_date')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('updated_date')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'updated_date' }])
                            }, _toDisplayString(_ctx.getSortIcon('updated_date')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_ctx.moment(row.updated_date).format('YYYY-MM-DD HH:mm:ss')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "created_by",
                    label: "作成者"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSort('created_by')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('created_by')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'created_by' }])
                            }, _toDisplayString(_ctx.getSortIcon('created_by')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "削除",
                    width: "52",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.organization_id !== _ctx.SYSTEM_ORGANIZATION)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "material-symbols-outlined cursor-pointer mt-2",
                            onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                          }, " delete ", 8, _hoisted_18))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.mCurrentPage,
                  "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                  "page-size": _ctx.mPageSize,
                  "onUpdate:pageSize": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.mPageSize) = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.mTotalRecords,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handlePageChange
                }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next",
                  total: _ctx.mTotalRecords,
                  onCurrentChange: _ctx.handlePageChange
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: _ctx.form.add_update === 'add' ? '新規登録' : '詳細',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_button, {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => _cache[31] || (_cache[31] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleAddUpdateSubmit(_ctx.formRef)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.form.add_update === 'add' ? '登録' : '更新'), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          "label-width": "140px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "コード",
              prop: "organization_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.organization_id,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.organization_id) = $event)),
                  autocomplete: "off",
                  disabled: _ctx.form.add_update === 'update',
                  placeholder: "コード"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "組織名",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.name) = $event)),
                  autocomplete: "off",
                  placeholder: "組織名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "払い出し操作者必須",
              prop: "is_pay_must"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.form.is_pay_must,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.is_pay_must) = $event)),
                  "active-value": "1",
                  "inactive-value": "0"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "下位部署ユーザーの払い出し許可",
              prop: "is_sub_pay_to_head_enabled"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.form.is_sub_pay_to_head_enabled,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.is_sub_pay_to_head_enabled) = $event)),
                  "active-value": "1",
                  "inactive-value": "0"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}